import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useOrganizationFeature } from '../organization-feature'
import { reportsMenuItemStyle } from './index'

interface FeatureGuardedDisaStigMenuItemProps {
  organizationID: string
  onClick: () => void
}

export function FeatureGuardedDisaStigMenuItem({
  organizationID,
  onClick
}: FeatureGuardedDisaStigMenuItemProps) {
  const { isLoading, enabled } = useOrganizationFeature(
    organizationID,
    'disa-stig'
  )

  if (isLoading || !enabled) {
    return null
  }

  return <DisaStigMenuItem onClick={onClick} />
}

interface DisaStigMenuItemProps {
  onClick: () => void
}

function DisaStigMenuItem({ onClick }: DisaStigMenuItemProps) {
  return (
    <React.Fragment>
      <li onClick={onClick} className={reportsMenuItemStyle}>
        <FormattedMessage id="title_applicationDashboard_stigViewerChecklist">
          {(title) => {
            return <span>{title}</span>
          }}
        </FormattedMessage>
      </li>
    </React.Fragment>
  )
}
